export enum LibraryType {
  FOLDER = 'folder',
  FILE = 'file'
}
